import { NError, NSuccess } from '@src/configs/const.config'
import { checkAuth } from '@libs/localStorage'
import { TResApi, TResApiErr } from '@src/configs/interface.config'
import { TBadgeCatalogRow, TUpdateBadgeSlot } from '@src/modules'
import { notification } from 'antd'
import { useMutation, useQuery } from 'react-query'

import { getBadgeCatalogAdmin, patchBadgeSlot } from '../apis/badge-admin'

import { queryClient } from '..'

export const BADGE_CATALOG_ADMIN = 'BADGE_CATALOG_ADMIN'

export const useBadgeCatalogAdmin = () => {
  const token = checkAuth()
  return useQuery<TResApi<TBadgeCatalogRow[]>>(
    [BADGE_CATALOG_ADMIN],
    () => getBadgeCatalogAdmin(token),
    { enabled: !!token },
  )
}

export const useUpdateBadgeSlot = () => {
  const token = checkAuth()
  return useMutation(
    ({ id, data }: { id: number; data: TUpdateBadgeSlot }) =>
      patchBadgeSlot(id, data, token),
    {
      onSuccess: (res: TResApi<TBadgeCatalogRow>) => {
        queryClient.invalidateQueries([BADGE_CATALOG_ADMIN])
        notification.success({ message: NSuccess, description: res?.message })
      },
      onError: (error: TResApiErr) =>
        notification.error({ message: NError, description: error?.message }),
    },
  )
}
